import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.561 5.97559C17.8421 5.69403 18 5.31239 18 4.91447C18 4.51656 17.8421 4.13492 17.561 3.85336L16.1477 2.43967C15.8661 2.15815 15.4843 2 15.0863 2C14.6882 2 14.3064 2.15815 14.0248 2.43967L12.5875 3.87735L16.1294 7.42013L17.561 5.97559ZM11.8803 4.58477L2.60052 13.8646L2.00983 17.2222C1.99158 17.3271 1.99882 17.4349 2.03095 17.5364C2.06308 17.6379 2.11915 17.7302 2.19443 17.8055C2.26971 17.8808 2.36199 17.9369 2.46349 17.969C2.56499 18.0012 2.67273 18.0084 2.77762 17.9902L6.13441 17.4016L15.4119 8.12183L11.8803 4.58477Z",
		fill: "#0D2976"
	})
});
export default SvgEdit;
